"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepeatWrapperContext = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lodash_1 = __importDefault(require("lodash"));
const CommonDialog_1 = __importDefault(require("../Modals/CommonDialog"));
const common_1 = require("../../utils/common");
const theme_1 = require("../../styles/theme");
const RepeatWrapperContext = react_1.default.createContext({
    toggleCollapse: () => { },
    repeatCollapsed: false,
    openDeleteConfirmation: (deleteItem, message) => { },
});
const RepeatWrapperWeb = props => {
    const [opened, setOpened] = react_1.default.useState(true);
    const [confirmationMessage, setConfirmationMessage] = react_1.default.useState('');
    const isMobileView = core_1.useMediaQuery(`(max-width: ${common_1.MOBILE_BREAKPOINT}px)`);
    const classes = useStyles();
    const deleteFn = react_1.useRef(lodash_1.default.noop);
    const toggleOpened = () => {
        setOpened(!opened);
    };
    const openDeleteConfirmation = (deleteItem, message) => {
        setConfirmationMessage(message);
        deleteFn.current = deleteItem;
    };
    const handleClose = (shouldDelete) => {
        setConfirmationMessage('');
        if (shouldDelete) {
            deleteFn.current();
        }
        deleteFn.current = lodash_1.default.noop;
    };
    // TODO - see what the form renderer can pass down to this wrapper as prop so this doesn't have to feel so hacky
    const firstFieldProp = react_1.useMemo(() => {
        if (props.children &&
            props.children[0] &&
            props.children[0].props.controlDefinition &&
            props.children[0].props.controlDefinition.type !== 'group') {
            return props.children[0].props;
        }
        return null;
    }, [props.children]);
    return (react_1.default.createElement(RepeatWrapperContext.Provider, { value: { toggleCollapse: toggleOpened, repeatCollapsed: !opened, openDeleteConfirmation } },
        firstFieldProp ? (react_1.default.createElement(core_1.Card, { className: classes.rootContainer },
            react_1.default.createElement(core_1.CardContent, { style: { padding: 0 } },
                react_1.default.createElement("div", { style: { width: '100%' } }, props.children)))) : (props.children),
        confirmationMessage && (react_1.default.createElement(CommonDialog_1.default, { title: 'Confirm', question: confirmationMessage, cancellationText: 'Cancel', confirmationText: 'Delete', onCancelPress: () => handleClose(false), onOkPress: () => handleClose(true), type: 'confirmation', isMobileView: isMobileView }))));
};
const useStyles = core_1.makeStyles(theme => ({
    rootContainer: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 5,
        border: `1px solid ${theme_1.colors.black10}`,
        background: theme_1.colors.white,
        boxShadow: 'none',
    }
}));
const useRepeatWrapperContext = () => react_1.default.useContext(RepeatWrapperContext);
exports.useRepeatWrapperContext = useRepeatWrapperContext;
exports.default = RepeatWrapperWeb;
//# sourceMappingURL=RepeatWrapperWeb.js.map